<div class="invite-players-modal">
  <!-- Header -->
  <div class="header">
    <button class="close-button" (click)="closeModal()">
      <img src="assets/icons/icon-close.svg" alt="Close" />
    </button>
  </div>

  <!-- Main Content Wrapper -->
  <div class="invitep-wrap">
    <!-- Wrap both sections in a single form -->
    <form [formGroup]="invitationForm" class="invitep-form align-items-stretch">
      <!-- Game Details Section -->
      <div class="invitep-main">
        <h4>GAME DETAILS</h4>
        <div class="game-details-form">
          <ul>
            <li class="form-group">
              <label>@if (!invitationForm.get('gameName')?.valid) {
                <span class="required-star">*</span>
              }Game Name:</label>
              <input type="text" formControlName="gameName" />
            </li>
            @if (invitationForm.get('gameName')?.touched && invitationForm.get('gameName')?.errors?.['required']) {
              <div
                class="text-danger">
                Field is required.
              </div>
            }
            <li class="form-group">
              <label for="character-type">@if (!invitationForm.get('gameSystem')?.valid) {
                <span class="text-danger"
                >*</span>
              }Game System:</label>
              <ng-select class="wt-select" formControlName="gameSystem" [items]="gamesystemlistdata"
                bindValue="value" bindLabel="value" placeholder="Choose…" [clearable]="false" appendTo="body">
                <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
              </ng-select>
            </li>
            @if (invitationForm.get('gameSystem')?.touched && invitationForm.get('gameSystem')?.errors?.['required']) {
              <div
                class="text-danger">
                Field is required.
              </div>
            }
          <li class="form-group">
            <span>MAP:</span> <span>{{ map_name || "%MAPNAME" }}</span>
          </li>
          <li class="form-group">
            <span>MAP GENRE:</span> <span>{{ map_genre || "%MAPGENRE" }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- Player Invitation Section -->
    <div class="player-detail">
      <div class="player-detail-col">
        <div class="pd-col-left">Invite players (email)</div>
        <div class="pd-col-right">LEVEL</div>
      </div>
      <div formArrayName="emailRows" class="email-row">
        @for (row of emailRows.controls; track row; let i = $index) {
          <ng-container [formGroupName]="i">
            <div class="pd-group">
              <div class="lbname">#{{ i + 1 }}:</div>
              <input type="email" formControlName="email" class="pemail" />
              <input type="number" formControlName="level" class="plevel" min="0" />
            </div>
            <div class="d-flex align-items-center  px-2">
              @if (row.get('email').dirty && row.get('email').errors) {
                <div class="text-danger w-100">
                  @if (row.get('email').errors['email']) {
                    <div>
                      Invalid email format.
                    </div>
                  }
                  @if (row.get('email')?.errors['strictEmail']) {
                    <div>
                      Invalid email format (e.g. example&#64;domain.com).
                    </div>
                  }
                </div>
              } @else {
              }
              @if (row.get('level')?.dirty && row.get('level')?.errors?.['min']) {
                <div
                  class="text-danger right-0">
                  Level must be greater than 0.
                </div>
              } @else {
              }
              @if (row.get('level')?.touched && row.get('level')?.errors?.['required']) {
                <div
                  class="text-danger right-0">
                  Field is required.
                </div>
              } @else {
              }
            </div>
          </ng-container>
        }
      </div>
    </div>
  </form>

  <!-- Token Upload and Action Buttons -->
  <div class="ai-token">
    <div class="ai-token-top" (click)="uploadPartyToken(game_details)">
      <h5>TOKEN</h5>
      <div class="image-container-token">
        <img [src]="partyToken?(imageurl + partyToken) :'assets/images/ac-token-game.png'" alt="" />
      </div>
      <input type="file" hidden />
      <div class="upload-section">
        <img src="assets/icons/icon-upload-outline.svg" alt="Upload" />
        <span>Click to select</span>
      </div>
      <div class="text-danger mt-2">{{ errorPartyToken }}</div>
    </div>
    <button type="button" class="btn btn-green" [ngClass]="{ 'mt-4': errorPartyToken.length > 0 }"
      (click)="sendEmail()" [disabled]="loading">
      {{ loading ? "Sending..." : "INVITE" }}
    </button>
    <button type="button" class="btn btn-dark" (click)="closeModal()">
      Back
    </button>
    <button type="button" class="btn btn-theme" (click)="backToGame()">
      Cancel
    </button>
  </div>
</div>
</div>